import React from "react";
import { Button } from "../../../atom/Button";
import { useTranslation } from "react-i18next";
import {
  CheckmarkFilled,
  CloseFilled,
  DocumentDownload,
  UserAvatarFilledAlt,
} from "@carbon/icons-react";
import { ServerFile } from "../../../../types/components";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../utils/consts/routes";

export interface ExamCardProps {
  title: string;
  type: string;
  questions: number;
  date: string;
  authorizedPerson: string;
  score: string;
  isPassed: boolean;
  certificate?: ServerFile;
}

export const RecentCard = ({
  title,
  type,
  questions,
  authorizedPerson,
  score,
  isPassed,
  date,
}: ExamCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="pt-5 bg-white rounded-[6px]">
      <div className="flex justify-between items-center mb-2 px-6">
        <p className={`text-[24px] font-semibold leading-[30.24px]`}>{title}</p>
        <div className="flex items-center justify-between mt-2">
          <p
            className={`text-[18px] font-normal leading-[22.68px] flex items-center gap-2 ${isPassed ? "text-green-700" : "text-red-500"}`}>
            {score} {isPassed ? <CheckmarkFilled size={18} /> : <CloseFilled size={18} />}
          </p>
        </div>
      </div>
      <div className="px-6 flex flex-col justify-start items-start gap-[6px] pb-8 pt-4">
        <div className="flex flex-col gap-[6px]">
          <div className="flex flex-row gap-[6px]">
            <p className="text-[16px] leading-[20.16px] text-black">{type}</p>
            <p className="text-[16px] font-light leading-[20.16px] text-gray-375">
              ({questions} {t("questions")})
            </p>
          </div>
          <div>
            <p className="text-[16px] leading-[20.16px] text-black">{date}</p>
          </div>
        </div>
      </div>
      <div className="p-6 pt-5 border-t border-gray-200">
        <div className="flex justify-between items-center">
          <div className="flex flex-col justify-start items-start gap-2">
            <p className="text-[13px] font-light leading-[16.38px] tracking-[0.2px] text-gray-375">
              {t("Authorized person")}:
            </p>
            <div className="flex flex-row justify-start items-center gap-1">
              <UserAvatarFilledAlt size={20} className="text-black" />
              <p className="text-black text-[16px] font-normal leading-[20.16px]">
                {authorizedPerson}
              </p>
            </div>
          </div>
          <div className="w-fit">
            {isPassed && (
              <Button
                type="secondary"
                label={t("Download Certificate")}
                additionalClassName="!h-10 !px-3 shadow-md"
                onClick={() => navigate(ROUTES.documents)}
                isDisabled={!isPassed}
                leftIcon={<DocumentDownload size={24} />}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
